<mat-accordion class="headers-align">
    <mat-expansion-panel [expanded]="isCustomerAPatient && patientsArray.length < 2" (afterCollapse)="markCustomerFormsTouched()">
        <mat-expansion-panel-header
            [style.background-color]="!areCustomerFieldsComplete && hasTouchedCustomerFields && areCustomerFieldsDirty ? 'rgb(237 20 61 / 20%)' : ''">
            <mat-panel-title>
                {{toTitle(form.controls['customerInformation'].get('title')?.value)}} {{form.controls['customerInformation'].get('lastName')?.value || ''}}
            </mat-panel-title>
            <mat-panel-description>Customer

                @if (!isReadMode && hasTouchedCustomerFields) {
                    <mat-icon [@fadeInOut] 
                    [ngClass]="{
                        'valid-icon': areCustomerFieldsDirty && areCustomerFieldsComplete, 
                        'invalid-icon': areCustomerFieldsDirty && !areCustomerFieldsComplete,
                        'warn-icon': !areCustomerFieldsComplete && hasTouchedCustomerFields && !areCustomerFieldsDirty
                    }">{{(areCustomerFieldsDirty && areCustomerFieldsComplete) || areCustomerFieldsComplete ? 'check_circle' : 'error'}}</mat-icon>
                }
            </mat-panel-description>
        </mat-expansion-panel-header>

        <lib-customer-signature-pages 
            [form]="form"
            [disabled]="isReadMode"
        ></lib-customer-signature-pages>
    </mat-expansion-panel>

    @if (patientsWhoMustSign.length > 0) {
    <!-- @if (!isCustomerAPatient || patientsArray.length > 0) { -->
    <!-- @for (patientForm of isCustomerAPatient ? patientsArray.controls : patientsArrayWithoutCustomer; track patientForm.value; let i = $index) -->
    @for (patientForm of patientsWhoMustSign; track patientForm.value; let i = $index)
    {
    <mat-expansion-panel (afterCollapse)="markPatientFormTouched(patientForm)">
        <mat-expansion-panel-header
            [style.background-color]="!arePatientFieldsComplete(patientForm) && hasTouchedPatientFields(patientForm) && arePatientFieldsDirty(patientForm) ? 'rgb(237 20 61 / 20%)' : ''"
        >
            <mat-panel-title>{{toTitle(patientForm.get('title')?.value)}} {{patientForm.get('lastName')?.value || ''}}</mat-panel-title>
            <mat-panel-description>Patient ({{i + 1}})

            @if (!isReadMode && hasTouchedPatientFields(patientForm)) {
                <mat-icon [@fadeInOut] 
                [ngClass]="{
                    'valid-icon': arePatientFieldsDirty(patientForm) && arePatientFieldsComplete(patientForm),
                    'invalid-icon': arePatientFieldsDirty(patientForm) && !arePatientFieldsComplete(patientForm),
                    'warn-icon': !arePatientFieldsComplete(patientForm) && hasTouchedPatientFields(patientForm) && !arePatientFieldsDirty(patientForm)
                }"
                >{{(arePatientFieldsDirty(patientForm) && arePatientFieldsComplete(patientForm)) || arePatientFieldsComplete(patientForm) ? 'check_circle' : 'error'}}</mat-icon>
            }
            </mat-panel-description>
        </mat-expansion-panel-header>
        
        <lib-patient-signature-pages 
            [vendorId]="form.controls['vendor'].value"
            [disabled]="isReadMode"
            [patientControl]="patientForm"
        ></lib-patient-signature-pages>
    </mat-expansion-panel>
    }
    }

</mat-accordion>